<template>
  <div class="d-flex flex-column justify-space-around align-center">
    <label class="text--primary">{{ title }}:</label>
    <label v-if="!loading" class="text--primary value">
      <slot />
    </label>
    <v-card-subtitle>
      {{ subtitle }}
    </v-card-subtitle>
    <v-skeleton-loader v-if="loading" type="table-cell" />
  </div>
</template>

<script>
export default {
  name: 'StatsValue',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.value {
  font-weight: bold;
  font-size: 24px;
}
</style>
